var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.headerValue)+" ")]),(!_vm.disabledEditMode)?_c('FilterMenu',{attrs:{"col":_vm.headerValue}}):_vm._e(),(_vm.hasFilteredTags)?_c('SaveFilteredView',{attrs:{"view":_vm.customView}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }